/**
 * License Request.
 *
 * @group DRM
 *
 * @beta
 */
export const LICENSE_REQUEST = 'license-request';
